import {Component, EventEmitter, OnDestroy, Output} from '@angular/core';

@Component({
  selector: 'app-popover-layout',
  standalone: true,
  imports: [],
  templateUrl: './popover-layout.component.html',
  styleUrl: './popover-layout.component.less',
})
export class PopoverLayoutComponent implements OnDestroy {
  @Output() destroy = new EventEmitter<void>();

  ngOnDestroy() {
    this.destroy.emit();
  }
}
